<accordion id="faqsAccordion" [isAnimated]="true" [closeOthers]="true">
  <accordion-group *ngFor="let faq of faqs | slice:0:this.sliceItems; let i = index "
    [heading]="(i+1) + '.- ' + faq.question" 
    [panelClass]="customClass"
    [isOpen]="i === 0"
  >
    <div [innerHTML]="faq.answer"></div>
  </accordion-group>
</accordion>